import { render, staticRenderFns } from "./DetectionStatistic.vue?vue&type=template&id=330db032"
import script from "./DetectionStatistic.vue?vue&type=script&lang=js"
export * from "./DetectionStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports